import { clsx } from 'clsx'
import { useAuth } from '@/features/auth/auth-context'
import { t, useLanguage } from '@/lib/i18n'

/**
 * Demo session only: "Sample data · nothing is saved". A tint-navy pill, 12/600 navy, in the top bar. At 900px and below the bar
 * has no room for it, so the shell renders the `strip` layout under the bar instead (a 28px full-width line): a sample session
 * is labelled on every screen at every width.
 */
export function SampleChip({ layout = 'pill' }: { layout?: 'pill' | 'strip' }) {
  useLanguage()
  const { demo } = useAuth()
  if (!demo) return null
  return <span className={clsx('r5-samplechip', layout === 'strip' && 'r5-samplechip--strip')}>{t('Sample data · nothing is saved')}</span>
}
